(function () {
  'use strict';

  var MAIN_PROP = '_lc_gift_flow';
  var MAIN_VALUE = 'main';

  function rootPath() {
    return window.Shopify?.routes?.root || '/';
  }

  /** Always return a full https URL or root-absolute path safe for location.href */
  function resolveShopUrl(pathOrUrl) {
    var fallback = '/pages/gift-add-ons';
    var raw = pathOrUrl || fallback;
    if (/^https?:\/\//i.test(raw)) return raw;

    var path = String(raw).trim();
    if (!path) path = fallback;
    if (path.indexOf('/') !== 0) {
      path = path.replace(/^pages\//i, 'pages/');
      if (path.indexOf('pages/') === 0) path = '/' + path;
      else if (path.indexOf('/') !== 0) path = '/pages/' + path.replace(/^\/+/, '');
    }

    var root = rootPath() || '/';
    if (root.indexOf('http') === 0) {
      return root.replace(/\/$/, '') + path;
    }
    var prefix = root.endsWith('/') ? root.slice(0, -1) : root;
    if (prefix === '') prefix = '';
    return window.location.origin + prefix + path;
  }

  function isGiftUpsellActive() {
    return (
      document.body.classList.contains('lc-gift-upsell-active') ||
      document.body.dataset.lcGiftUpsellActive === '1' ||
      !!document.querySelector('[data-lc-gift-upsell-config]')
    );
  }

  function parseConfig() {
    var el = document.querySelector('[data-lc-gift-upsell-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_) {
      return null;
    }
  }

  function lineItemProperties(form) {
    var props = Object.create(null);
    if (!form) return props;
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (!match || !field.value) return;
      props[match[1]] = field.value;
    });
    return props;
  }

  function gemWeightActive(weightRoot) {
    if (!weightRoot || weightRoot.hidden) return false;
    return !!weightRoot.querySelector('[data-lc-gem-weight-select]');
  }

  function ensureGemWeightApplied(pdp) {
    var weightRoot = pdp.querySelector('[data-lc-gem-weight]');
    if (!gemWeightActive(weightRoot)) return true;
    if (weightRoot.dataset.lcGemWeightInit !== 'true') return false;

    var select = weightRoot.querySelector('[data-lc-gem-weight-select]');
    if (select && select.options.length) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!weightRoot.dataset.lcGemWeightSelected) {
      if (select) {
        select.focus();
        if (select.reportValidity) select.reportValidity();
      }
      return false;
    }
    return true;
  }

  function resolveVariantId(pdp, form) {
    var weightRoot = pdp.querySelector('[data-lc-gem-weight]');
    if (gemWeightActive(weightRoot) && !weightRoot.dataset.lcGemWeightSelected) {
      return null;
    }
    if (weightRoot && weightRoot.dataset.lcCheckoutPriceReady === '0') {
      window.alert(
        weightRoot.getAttribute('data-checkout-blocked-msg') ||
          'This weight is not available for checkout yet. Please select the default weight (base price) or contact support.'
      );
      return null;
    }
    var id = form.querySelector('[name="id"]')?.value;
    if (weightRoot?.dataset.lcResolvedVariantId) {
      id = weightRoot.dataset.lcResolvedVariantId;
    }
    return id;
  }

  async function fetchAddToCart(variantId, quantity, properties) {
    var item = { id: Number(variantId), quantity: Number(quantity) || 1 };
    if (properties && Object.keys(properties).length) {
      item.properties = properties;
    }
    var res = await fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    var data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok) {
      throw new Error(data.description || data.message || 'Could not add to cart');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return data;
  }

  function initModal(config) {
    var modal = document.querySelector('[data-lc-gift-upsell]');
    if (!modal) return null;

    var yesBtn = modal.querySelector('[data-lc-gift-upsell-yes]');
    var skipBtn = modal.querySelector('[data-lc-gift-upsell-skip]');
    var checkoutUrl = resolveShopUrl(
      skipBtn?.getAttribute('data-lc-gift-upsell-href') || config.checkoutUrl || rootPath() + 'checkout'
    );
    var addonsUrl = resolveShopUrl(yesBtn?.getAttribute('data-lc-gift-upsell-href') || config.addonsPageUrl);

    function navigate(url) {
      window.location.assign(resolveShopUrl(url));
    }

    function open() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.documentElement.classList.add('lc-gift-upsell--lock');
    }

    modal.querySelector('[data-lc-gift-upsell-close]')?.addEventListener('click', function () {
      navigate(checkoutUrl);
    });
    modal.querySelector('[data-lc-gift-upsell-backdrop]')?.addEventListener('click', function () {
      navigate(checkoutUrl);
    });
    skipBtn?.addEventListener('click', function () {
      navigate(skipBtn.getAttribute('data-lc-gift-upsell-href') || checkoutUrl);
    });
    yesBtn?.addEventListener('click', function () {
      navigate(yesBtn.getAttribute('data-lc-gift-upsell-href') || addonsUrl);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        e.preventDefault();
        navigate(checkoutUrl);
      }
    });

    return { open: open };
  }

  async function addGiftMainAndShowModal(pdp, form) {
    if (!ensureGemWeightApplied(pdp)) return false;

    var variantId = resolveVariantId(pdp, form);
    if (!variantId) return false;

    var qty = form.querySelector('[name="quantity"]')?.value || 1;
    var props = lineItemProperties(form);
    props[MAIN_PROP] = MAIN_VALUE;

    if (window.lcAddToCart && window.lcAddToCart.__lcGiftWrapped) {
      await window.lcAddToCart(variantId, qty, props);
    } else {
      await fetchAddToCart(variantId, qty, props);
      if (window.__lcGiftUpsellModal) window.__lcGiftUpsellModal.open();
    }
    return true;
  }

  function wrapLcAddToCart() {
    if (!isGiftUpsellActive() || !window.lcAddToCart || window.lcAddToCart.__lcGiftWrapped) return;

    window.lcAddToCart = async function (variantId, quantity, properties) {
      var props = properties && typeof properties === 'object' ? Object.assign({}, properties) : {};
      props[MAIN_PROP] = MAIN_VALUE;

      var data = await fetchAddToCart(variantId, quantity, props);
      if (window.__lcGiftUpsellModal) {
        window.__lcGiftUpsellModal.open();
      }
      return data;
    };
    window.lcAddToCart.__lcGiftWrapped = true;
  }

  function hideAcceleratedCheckout() {
    document.querySelectorAll('[data-lc-pdp] .shopify-payment-button, [data-lc-pdp] shopify-accelerated-checkout').forEach(function (el) {
      el.setAttribute('data-lc-gift-hidden-pay', '1');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function injectGiftBuyNowButtons() {
    document.querySelectorAll('[data-lc-pdp]').forEach(function (pdp) {
      var actions = pdp.querySelector('.lc-pdp__actions');
      var form = pdp.querySelector('.lc-pdp__form');
      if (!actions || !form || actions.querySelector('[data-lc-gift-buy-now]')) return;

      hideAcceleratedCheckout();

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lc-gift-upsell-buy-now';
      btn.setAttribute('data-lc-gift-buy-now', '1');
      btn.textContent = 'Buy it now';
      actions.appendChild(btn);

      btn.addEventListener('click', async function () {
        if (btn.disabled) return;
        btn.disabled = true;
        try {
          await addGiftMainAndShowModal(pdp, form);
        } catch (err) {
          window.alert(err.message || 'Could not add to cart');
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  function isPaymentClick(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.tagName) continue;
      if (node.matches && node.matches('.shopify-payment-button, .shopify-payment-button__more-options, shopify-accelerated-checkout, shopify-buy-it-now-button')) {
        return true;
      }
      if (node.classList && node.classList.contains('shopify-payment-button__button')) return true;
    }
    return false;
  }

  function bindAcceleratedCheckoutGuard() {
    document.addEventListener(
      'click',
      function (e) {
        if (!isGiftUpsellActive()) return;
        if (!isPaymentClick(e)) return;
        var form = e.target.closest && e.target.closest('.lc-pdp__form');
        if (!form) {
          var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
          for (var i = 0; i < path.length; i++) {
            if (path[i].classList && path[i].classList.contains('lc-pdp__form')) {
              form = path[i];
              break;
            }
          }
        }
        if (!form) return;
        var pdp = form.closest('[data-lc-pdp]');
        if (!pdp) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        addGiftMainAndShowModal(pdp, form).catch(function (err) {
          window.alert(err.message || 'Could not add to cart');
        });
      },
      true
    );
  }

  function init() {
    var config = parseConfig();
    if (!config) return;

    document.body.dataset.lcGiftUpsellActive = '1';
    document.body.classList.add('lc-gift-upsell-active');

    window.__lcGiftUpsellModal = initModal(config);
    wrapLcAddToCart();
    if (!window.lcAddToCart) {
      window.setTimeout(wrapLcAddToCart, 0);
      window.setTimeout(wrapLcAddToCart, 500);
    }

    injectGiftBuyNowButtons();
    bindAcceleratedCheckoutGuard();

    window.setTimeout(hideAcceleratedCheckout, 800);
    window.setTimeout(injectGiftBuyNowButtons, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
